import React from 'react'
import FramedLayout from '~layouts/FramedLayout'
import ThreeColumnLayout from '~layouts/ThreeColumnLayout'

import Footer from '~components/Footer'

const ReferenceLayout = ({
  alignment,
  displaySidebar,
  setDisplaySidebar,
  children
}) => (
  <FramedLayout showHeader showSearch>
    { children[0] }
    <ThreeColumnLayout alignment={alignment} displaySidebar={displaySidebar} setDisplaySidebar={setDisplaySidebar}>
      { children[1] }
      { children[2] }
      { children[3] }
    </ThreeColumnLayout>
    <Footer />
  </FramedLayout>
)

export default ReferenceLayout 
